export default{
  "Mute Video": "Silenciar video",
  "HitPaw Online Mute Video": "HitPaw silenciar video online",
  "Fast and easy to remove sound from your video online": "Rápido y fácil de quitar el sonido de tu video online",
  "Muting": "Silenciando",
  "Mute Failed": "Silenciar falló",
  "Mute New": "Silenciar nuevo"
};